import { render, staticRenderFns } from "./deviceDetail.vue?vue&type=template&id=6cf60a6f&scoped=true"
import script from "./deviceDetail.vue?vue&type=script&lang=js"
export * from "./deviceDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf60a6f",
  null
  
)

export default component.exports